import AnswerText from './AnswerText';

const noAnswerStyles = { fontStyle: 'italic', color: 'devblue.90' } as const;

interface NoAnswerProps {
    text?: string;
}

const NoAnswer: React.FC<NoAnswerProps> = ({ text = 'Answer could not be provided.' }) => (
    <AnswerText sx={noAnswerStyles}>{text}</AnswerText>
);

export default NoAnswer;
